import styled from 'styled-components';

export const LoadingBox = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .loading-icon {
        width: 110px;
        height: 110px;
    }

    .loading-title {
        margin: 4px 0 24px 0;
    }

    .loading-title,
    .loading-description {
        text-align: center;
        margin: 0;
    }
`;
